// eslint-disable-next-line import/no-webpack-loader-syntax
import Worker from 'worker-loader!./worker'
import * as Comlink from 'comlink'

const worker = Comlink.wrap(new Worker())

export const jsonToXLSXWB = worker.jsonToXLSXWB
export const sortJsonOnKey = worker.sortJsonOnKey
